import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogProps,
} from "@mui/material";
import ButtonBox from "./ButtonBox";

interface DialogBoxProps extends Omit<DialogProps, "onClose"> {
  title: string; // 對話框標題
  dialogContent: React.ReactNode; // 對話框內容
  showCancel?: boolean;
  onCancel: () => void; // 點擊取消的處理函數
  onConfirm: () => void; // 點擊確認的處理函數
  confirmLabel?: string; // 確認按鈕文字
  cancelLabel?: string; // 取消按鈕文字
  isError?: boolean;
}

const DialogBox: React.FC<DialogBoxProps> = ({
  title,
  dialogContent,
  showCancel = true,
  onCancel,
  onConfirm,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  maxWidth = "sm",
  fullWidth = true,
  isError = false,
  ...dialogProps
}) => {
  return (
    <Dialog maxWidth={maxWidth} fullWidth={fullWidth} {...dialogProps}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{dialogContent}</DialogContent>
      <DialogActions>
        {showCancel && (
          <ButtonBox onClick={onCancel} text={cancelLabel} variant="outlined" />
        )}
        <ButtonBox onClick={onConfirm} text={confirmLabel} isError={isError} />
      </DialogActions>
    </Dialog>
  );
};

export default DialogBox;
